import React from 'react';

import Logo from 'web/components/common/modal/common/Logo';
import CustomScrollbar from 'web/components/common/CustomScrollbar';

import classNames from 'classnames/bind';
import styles from './ScriptBox.scss';
import PolicyContent from 'web/routes/info/PolicyContent';
const cx = classNames.bind(styles);

const ScriptBox = React.memo(
  ({ title = '', content = '', style = {}, children, className = [] }) => {
    return (
      <div className={cx('ScriptBox', ...className)} style={style}>
        {title ? <Logo title={title} /> : null}
        {content ? (
          <CustomScrollbar
            style={{
              border: '1px solid #ddd',
              borderRadius: '5px',
            }}
          >
            <pre style={{ padding: '10px' }}>{PolicyContent}</pre>
          </CustomScrollbar>
        ) : null}
        {children}
      </div>
    );
  },
);

export default ScriptBox;
